import { useState } from 'react';
import { cx } from '@/utils';

import { useModalSearchStore } from '@/utils/store/store';

import CustomLink from '../../../common/CustomLink';
import SvgSearch from '../../../common/Icons/Search';
import { useLayoutContext } from '../../../common/Layout/LayoutProvider/LayoutContext';
import MobileCollapsibleMenu from '../../PageNavigationBar/public/MobileCollapsibleMenu';

const MobileHeader = () => {
  const {
    layout: { headerOrganizationBar, searchBlock },
  } = useLayoutContext();
  const { onShow } = useModalSearchStore();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const isSearchEnabled = searchBlock && !searchBlock.isDisabled;

  return (
    <>
      <div className="relative z-50 inline-flex w-full items-center justify-between bg-[#0943B5] px-4 py-4">
        {/* Hamburger button - left side */}
        <button className="relative h-8 w-8 focus:outline-none" onClick={toggleMobileMenu}>
          <span className="sr-only">Toggle menu</span>
          <div className="absolute left-1/2 top-1/2 block w-5 -translate-x-1/2 -translate-y-1/2">
            <span
              aria-hidden="true"
              className={cx(
                'absolute block h-0.5 w-5 transform bg-white transition duration-500 ease-in-out',
                isMobileMenuOpen ? 'rotate-45' : '-translate-y-1.5'
              )}
            ></span>
            <span
              aria-hidden="true"
              className={cx(
                'absolute block h-0.5 w-5 transform bg-white transition duration-500 ease-in-out',
                isMobileMenuOpen ? 'opacity-0' : 'opacity-100'
              )}
            ></span>
            <span
              aria-hidden="true"
              className={cx(
                'absolute block h-0.5 w-5 transform bg-white transition duration-500 ease-in-out',
                isMobileMenuOpen ? '-rotate-45' : 'translate-y-1.5'
              )}
            ></span>
          </div>
        </button>

        {/* Center content - logo and titles */}
        <div className="flex items-center justify-center">
          {headerOrganizationBar?.logoImage && (
            <CustomLink
              pageLink={headerOrganizationBar.logoImageLink}
              className={'relative h-[35px] w-[35px] md:h-[48px] md:w-[50px]'}
            >
              <img
                src={`${headerOrganizationBar.logoImage.downloadUrl}`}
                alt={'logo'}
                className="h-[35px] w-[35px] object-contain md:h-[48px] md:w-[50px]"
              />
            </CustomLink>
          )}
          <div>
            <div className="font-workSans text-base font-semibold uppercase leading-[14px] text-white">
              {headerOrganizationBar?.title}
            </div>
            <div className="font-workSans text-xs uppercase leading-[14px] text-white">
              {headerOrganizationBar?.subtitle}
            </div>
          </div>
        </div>

        {/* Search button - right side */}
        <button
          className={cx('h-8 w-8 items-center justify-center rounded-full bg-white', {
            flex: isSearchEnabled,
            invisible: !isSearchEnabled,
          })}
          onClick={() => {
            onShow(true);
          }}
        >
          <SvgSearch width={20} height={20} className="fill-marine" />
        </button>
      </div>

      <MobileCollapsibleMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        headerHeight="67px"
      />
    </>
  );
};

export default MobileHeader;
